import { bootstrapApplication } from '@angular/platform-browser';
import {
  bootstrapAccessTokenFromUrl,
  handlePeerLogoutFromUrl,
  markFreshSsoCallback,
} from '@cei-ufg/ngx-cei-sso-client';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const ACCESS_TOKEN_KEYS = ['access_token', 'access', 'token', 'accessToken'] as const;

function preBootstrapCaptureAccessToken(): void {
  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;
  const hashParams = new URLSearchParams(hash);
  const hasTokenInUrl = ACCESS_TOKEN_KEYS.some(
    (key) => hashParams.has(key) || window.location.search.includes(`${key}=`),
  );

  if (hasTokenInUrl) {
    document.cookie = 'cei_sso_logout=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    bootstrapAccessTokenFromUrl('access_token', [...ACCESS_TOKEN_KEYS], 'localStorage');
    markFreshSsoCallback();
  }
}

handlePeerLogoutFromUrl([...ACCESS_TOKEN_KEYS], 'localStorage');
preBootstrapCaptureAccessToken();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
